import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import {
  ClientDocumentVerificationStatus,
  clientDocumentMetadata
} from 'src/app/shared/api-services/cms/models/client-document.model';
import { ClientDocumentService } from 'src/app/shared/api-services/cms/services/client-document.service';

@Component({
  selector: 'app-profile-docs-reminder',
  templateUrl: './profile-docs-reminder.component.html',
  styleUrls: ['./profile-docs-reminder.component.scss']
})
export class ProfileDocsReminderComponent implements OnInit, OnDestroy {
  uploadedDocumentCount = 0;
  readonly totalDocumentCount = clientDocumentMetadata.length;
  showReminder = false;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly authService: AuthService,
    private readonly clientDocumentService: ClientDocumentService
  ) {}

  ngOnInit(): void {
    this.authService.user$
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => this.loadClientDocuments(user.id));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadClientDocuments(clientId: string): void {
    this.showReminder = false;

    this.clientDocumentService.getClientDocuments(clientId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.uploadedDocumentCount = response?.documents?.length || 0;
          this.showReminder = this.uploadedDocumentCount !== this.totalDocumentCount
            && response?.verificationStatus !== ClientDocumentVerificationStatus.FULLY_VERIFIED;
        },
        error: () => {
          this.showReminder = false;
        }
      });
  }

}
